export const PosInterfaces: { [key: string]: string } = {
  NEXO: "NEXO",
  OPI: "OPI"
};

export const PosAuthentication: { [key: string]: string } = {
  hsm: "hsm",
  local: "local"
};